import { themeColors } from '@hg/stylizator/utils'
import styled from 'styled-components'

export default styled.span.withConfig({ shouldForwardProp: (prop) => !['mobile'].includes(prop) })<{ mobile?: true }>`
  width: ${(props) => (props.mobile ? 48 : 32)}px;
  height: ${(props) => (props.mobile ? 3 : 2)}px;
  background-color: ${themeColors.gray['90']};
  margin: 0;
`
